import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { rolAccessOutComponent } from '../rolAccess/rolAccessOut.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/rolaccess', component: rolAccessOutComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class RolAccessRoutingModule {}
